import styled from "@emotion/styled";
import {
  transparentize,
  respond,
  defaultFocusStyle,
  headerContainerPrimary,
  containerPrototype,
  defaultTransitionProps
} from "theme/styles/mixins";

export const Dialog = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  font-size: 18px;
  font-family: var(--font-family-copy);
  background-color: ${transparentize("neutral90", 0.025)};
  z-index: 600;
  transition: opacity ${defaultTransitionProps};

  &[inert] {
    opacity: 0;
  }

  a {
    text-decoration: underline;
  }
`;

export const Header = styled.div`
  position: fixed;
  width: 100%;
  z-index: 1;
`;

export const HeaderInner = styled.div`
  ${headerContainerPrimary}
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Content = styled.div`
  position: absolute;
  top: 80px;
  bottom: 0;
  width: 100%;
  overflow: auto;

  ${respond(`top: 0;`, 90)}
`;

export const LayoutContainer = styled.div`
  ${containerPrototype}
  padding-block-start: var(--container-padding-block-start);
  padding-block-end: 100px;
`;

export const FormContainer = styled.div`
  max-width: 340px;
  margin: 0 auto;

  ${respond(`padding-top: 35px;`, 40)}
  ${respond(`padding-top: 126px;`, 90)}

  form {
    &:focus:not(:focus-visible) {
      outline: 0;
    }

    &:focus-visible {
      ${defaultFocusStyle}
      outline-offset: 5px;
    }
  }
`;
